var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('fieldset', [_c('legend', [_vm._v("User Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("User Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.utype),
      expression: "userDetails.utype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('utype')
    },
    attrs: {
      "name": "utype",
      "id": "utype",
      "disabled": _vm.useraction == 'edit' ? false : false
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.utype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.callAPI()
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a User Type")]), _vm._v(" "), _vm._l((_vm.listUserTypeData), function(usertype_obj) {
    return _c('option', {
      domProps: {
        "value": usertype_obj.usertypeid
      }
    }, [_vm._v(_vm._s(usertype_obj.usertypename))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('utype')),
      expression: "errors.has('utype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The User Type field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Username")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('username')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter User Name",
      "name": "username",
      "id": "username"
    },
    model: {
      value: (_vm.userDetails.username),
      callback: function($$v) {
        _vm.userDetails.username = $$v
      },
      expression: "userDetails.username"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('username')) + "\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("User Email")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 ? 'required|email|verify_email' : _vm.userDetails.utype == 3 ? 'email|verify_email': 'required|email'))),
      expression: "`${userDetails.utype == 2 ? 'required|email|verify_email' : userDetails.utype == 3 ? 'email|verify_email': 'required|email' }`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('email')
    },
    attrs: {
      "type": "email",
      "placeholder": "Enter Email Address",
      "name": "email",
      "id": "email"
    },
    model: {
      value: (_vm.userDetails.email),
      callback: function($$v) {
        _vm.userDetails.email = $$v
      },
      expression: "userDetails.email"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1)], 1)]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.useraction == 'add' || (_vm.verify_clientid && _vm.verify_clientid == _vm.userDetails.clientid)) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("User Password")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-lock'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|verify_password'),
      expression: "'required|verify_password'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('password')
    },
    attrs: {
      "type": "password",
      "pattern": "(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}",
      "title": "Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters",
      "placeholder": "Enter User Password",
      "name": "password",
      "id": "userpassword"
    },
    model: {
      value: (_vm.userDetails.password),
      callback: function($$v) {
        _vm.userDetails.password = $$v
      },
      expression: "userDetails.password"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.useraction == 'add' || (_vm.verify_clientid && _vm.verify_clientid == _vm.userDetails.clientid)) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("User Confirm Password")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-lock'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:password'),
      expression: "'required|confirmed:password'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('confirmpassword')
    },
    attrs: {
      "type": "password",
      "placeholder": "Enter Confirm Password",
      "name": "confirmpassword",
      "id": "userconfirmpassword",
      "data-vv-as": "password"
    },
    model: {
      value: (_vm.confirmpassword),
      callback: function($$v) {
        _vm.confirmpassword = $$v
      },
      expression: "confirmpassword"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirmpassword')),
      expression: "errors.has('confirmpassword')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('confirmpassword')))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirmpassword')),
      expression: "errors.has('confirmpassword')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password_confirmation')))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.string",
      value: (_vm.userDetails.status),
      expression: "userDetails.status",
      modifiers: {
        "string": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('status')
    },
    attrs: {
      "name": "status",
      "id": "status",
      "disabled": _vm.useraction == 'edit' ? false : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("InActive")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('status')),
      expression: "errors.has('status')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Status field is required.")])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3),
      expression: "userDetails.utype == 2 || userDetails.utype == 3"
    }],
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Employee ID")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 ? 'required|numeric' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 ? 'required|numeric' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('EmployeeID')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Employee ID",
      "name": "EmployeeID",
      "id": "EmployeeID",
      "disabled": _vm.useraction == 'edit' ? true : false
    },
    model: {
      value: (_vm.userDetails.EmployeeID),
      callback: function($$v) {
        _vm.userDetails.EmployeeID = $$v
      },
      expression: "userDetails.EmployeeID"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('EmployeeID')),
      expression: "errors.has('EmployeeID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('EmployeeID')) + "\n                ")])], 1)], 1)])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("User Personal Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("First Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha_spaces'),
      expression: "'required|alpha_spaces'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('FirstName')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter First Name",
      "name": "FirstName",
      "id": "FirstName"
    },
    model: {
      value: (_vm.userDetails.FirstName),
      callback: function($$v) {
        _vm.userDetails.FirstName = $$v
      },
      expression: "userDetails.FirstName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('FirstName')),
      expression: "errors.has('FirstName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('FirstName')) + "\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3),
      expression: "userDetails.utype == 2 || userDetails.utype == 3"
    }],
    staticClass: "col-md-4",
    attrs: {
      "id": "divAuDuMiddle"
    }
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Middle Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('alpha'),
      expression: "'alpha'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Middle Name",
      "name": "MiddleName",
      "id": "MiddleName"
    },
    model: {
      value: (_vm.userDetails.MiddleName),
      callback: function($$v) {
        _vm.userDetails.MiddleName = $$v
      },
      expression: "userDetails.MiddleName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('MiddleName')),
      expression: "errors.has('MiddleName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('MiddleName')) + "\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3),
      expression: "userDetails.utype == 2 || userDetails.utype == 3"
    }],
    staticClass: "col-md-4",
    attrs: {
      "id": "divAuDuLast"
    }
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Last Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 ? 'required|alpha' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 ? 'required|alpha' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('LastName')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Last Name",
      "name": "LastName",
      "id": "LastName"
    },
    model: {
      value: (_vm.userDetails.LastName),
      callback: function($$v) {
        _vm.userDetails.LastName = $$v
      },
      expression: "userDetails.LastName"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('LastName')),
      expression: "errors.has('LastName')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('LastName')) + "\n                ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3),
      expression: "userDetails.utype == 2 || userDetails.utype == 3"
    }],
    staticClass: "form-group row",
    attrs: {
      "id": "divAuDuSex"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Gender")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.Sex),
      expression: "userDetails.Sex"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 ? 'required' : ''}`"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('Sex')
    },
    attrs: {
      "name": "Sex",
      "id": "Sex"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.Sex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Sex")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v("Female")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "O"
    }
  }, [_vm._v("Other")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Sex')),
      expression: "errors.has('Sex')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Gender field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Age")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 ? 'required|digits:2' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 ? 'required|digits:2' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Age')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Age",
      "name": "Age",
      "id": "Age",
      "maxlength": 2
    },
    model: {
      value: (_vm.userDetails.Age),
      callback: function($$v) {
        _vm.userDetails.Age = $$v
      },
      expression: "userDetails.Age"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Age')),
      expression: "errors.has('Age')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Age')) + "\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Date Of Birth")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-times-o'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 ? 'required' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('DateOfBirth')
    },
    attrs: {
      "type": "date",
      "placeholder": "Enter Date Of Birth",
      "name": "DateOfBirth",
      "id": "DateOfBirth",
      "max": "9999-12-31"
    },
    model: {
      value: (_vm.userDetails.DateOfBirth),
      callback: function($$v) {
        _vm.userDetails.DateOfBirth = $$v
      },
      expression: "userDetails.DateOfBirth"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('DateOfBirth')),
      expression: "errors.has('DateOfBirth')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('DateOfBirth')) + "\n                ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3),
      expression: "userDetails.utype == 2 || userDetails.utype == 3"
    }],
    staticClass: "form-group row",
    attrs: {
      "id": "divAuDuDOJ"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Date Of Joining")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-times-o'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 ? 'required|verify_doj' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 ? 'required|verify_doj' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('DateOfJoining')
    },
    attrs: {
      "type": "date",
      "placeholder": "Enter Date Of Joining",
      "name": "DateOfJoining",
      "id": "DateOfJoining",
      "max": "9999-12-31"
    },
    model: {
      value: (_vm.userDetails.DateOfJoining),
      callback: function($$v) {
        _vm.userDetails.DateOfJoining = $$v
      },
      expression: "userDetails.DateOfJoining"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('DateOfJoining')),
      expression: "errors.has('DateOfJoining')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('DateOfJoining')) + "\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Date Of Relieving")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-times-o'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('verify_dor'),
      expression: "'verify_dor'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('DateOfRelieving')
    },
    attrs: {
      "type": "date",
      "value": "",
      "placeholder": "Enter Date Of Relieving",
      "name": "DateOfRelieving",
      "id": "DateOfRelieving",
      "max": "9999-12-31"
    },
    model: {
      value: (_vm.userDetails.DateOfRelieving),
      callback: function($$v) {
        _vm.userDetails.DateOfRelieving = $$v
      },
      expression: "userDetails.DateOfRelieving"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('DateOfRelieving')),
      expression: "errors.has('DateOfRelieving')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('DateOfRelieving')) + "\n                ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Notice Period")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user-times'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.NoticePeriod),
      expression: "userDetails.NoticePeriod"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 ? 'required' : ''}`"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('NoticePeriod')
    },
    attrs: {
      "name": "NoticePeriod",
      "id": "NoticePeriod"
    },
    domProps: {
      "value": _vm.NoticePeriod
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.NoticePeriod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Notice Period")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "No"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('NoticePeriod')),
      expression: "errors.has('NoticePeriod')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Notice Period field is required.")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    attrs: {
      "id": "divAuDuPersonal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3),
      expression: "userDetails.utype == 2 || userDetails.utype == 3"
    }],
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Personal Email Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('PersonalEmailId')
    },
    attrs: {
      "type": "email",
      "placeholder": "Enter Personal Email Id",
      "name": "PersonalEmailId",
      "id": "PersonalEmailId"
    },
    model: {
      value: (_vm.userDetails.PersonalEmailId),
      callback: function($$v) {
        _vm.userDetails.PersonalEmailId = $$v
      },
      expression: "userDetails.PersonalEmailId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('PersonalEmailId')),
      expression: "errors.has('PersonalEmailId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Personal Email Id field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 || _vm.userDetails.utype == 5),
      expression: "userDetails.utype == 2 || userDetails.utype == 3 || userDetails.utype == 5"
    }],
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Mobile Number")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-mobile'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 || _vm.userDetails.utype == 5? 'required|digits:10' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 || userDetails.utype == 5? 'required|digits:10' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('MobileNumber')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Mobile Number",
      "maxlength": 10,
      "name": "MobileNumber",
      "id": "MobileNumber"
    },
    model: {
      value: (_vm.userDetails.MobileNumber),
      callback: function($$v) {
        _vm.userDetails.MobileNumber = $$v
      },
      expression: "userDetails.MobileNumber"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('MobileNumber')),
      expression: "errors.has('MobileNumber')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('MobileNumber')))])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3),
      expression: "userDetails.utype == 2 || userDetails.utype == 3"
    }],
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Phone Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-phone'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('verify_phone|max:20'),
      expression: "'verify_phone|max:20'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('PhoneNumber')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Phone Number",
      "name": "PhoneNumber",
      "id": "PhoneNumber"
    },
    model: {
      value: (_vm.userDetails.PhoneNumber),
      callback: function($$v) {
        _vm.userDetails.PhoneNumber = $$v
      },
      expression: "userDetails.PhoneNumber"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('PhoneNumber')),
      expression: "errors.has('PhoneNumber')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('PhoneNumber')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3),
      expression: "userDetails.utype == 2 || userDetails.utype == 3"
    }],
    staticClass: "form-group row",
    attrs: {
      "id": "divAuDuAddr"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Address")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-address-card'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 ? 'required' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Address')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Address",
      "name": "Address",
      "id": "Address"
    },
    model: {
      value: (_vm.userDetails.Address),
      callback: function($$v) {
        _vm.userDetails.Address = $$v
      },
      expression: "userDetails.Address"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Address')),
      expression: "errors.has('Address')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Address field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("State")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-book'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.StateId),
      expression: "userDetails.StateId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 ? 'required' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('StateId')
    },
    attrs: {
      "name": "StateId",
      "id": "StateId"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.StateId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getCityData]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a State")]), _vm._v(" "), _vm._l((_vm.stateList), function(state_obj) {
    return _c('option', {
      domProps: {
        "value": state_obj.stateid
      }
    }, [_vm._v(_vm._s(state_obj.statename))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('StateId')),
      expression: "errors.has('StateId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The State field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("City")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-book'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.CityId),
      expression: "userDetails.CityId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 ? 'required' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('CityId')
    },
    attrs: {
      "name": "CityId",
      "id": "CityId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.CityId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a City")]), _vm._v(" "), _vm._l((_vm.cityList), function(city_obj) {
    return _c('option', {
      domProps: {
        "value": city_obj.cityid
      }
    }, [_vm._v(_vm._s(city_obj.cityname))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('CityId')),
      expression: "errors.has('CityId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The City field is required.")])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3),
      expression: "userDetails.utype == 2 || userDetails.utype == 3"
    }],
    staticClass: "form-group row",
    attrs: {
      "id": "divAuDuCoun"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Country")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-flag'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 ? 'required' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Country')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Country",
      "name": "Country",
      "id": "Country"
    },
    model: {
      value: (_vm.userDetails.Country),
      callback: function($$v) {
        _vm.userDetails.Country = $$v
      },
      expression: "userDetails.Country"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Country')),
      expression: "errors.has('Country')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Country field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Pincode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 ? 'required|numeric|max:6|min:6' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 ? 'required|numeric|max:6|min:6' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Pincode')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter PIN Code",
      "name": "Pincode",
      "id": "Pincode",
      "maxlength": 6
    },
    model: {
      value: (_vm.userDetails.Pincode),
      callback: function($$v) {
        _vm.userDetails.Pincode = $$v
      },
      expression: "userDetails.Pincode"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Pincode')),
      expression: "errors.has('Pincode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Pincode')))])], 1)], 1)])]), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 1 || _vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 || _vm.userDetails.utype == 4),
      expression: "userDetails.utype == 1 || userDetails.utype == 2 || userDetails.utype == 3 || userDetails.utype == 4"
    }],
    attrs: {
      "id": "otherClient"
    }
  }, [_c('legend', [_vm._v("Other Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 1 || _vm.userDetails.utype == 4),
      expression: "userDetails.utype == 1 || userDetails.utype == 4"
    }],
    staticClass: "col-md-4",
    attrs: {
      "id": "divOthClientId"
    }
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Client Id")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-globe'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.clientid),
      expression: "userDetails.clientid"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 1 || _vm.userDetails.utype == 4 ? 'required' : ''))),
      expression: "`${userDetails.utype == 1 || userDetails.utype == 4 ? 'required' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('clientid')
    },
    attrs: {
      "name": "clientid",
      "id": "clientid"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.clientid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getBusinessAccountIds(_vm.userDetails.clientid)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a Client")]), _vm._v(" "), _vm._l((_vm.clientList), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.ClientMasterID
      }
    }, [_vm._v(_vm._s(client_obj.CompanyName + ' ' + '(' + client_obj.ClientMasterID + ')'))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientid')),
      expression: "errors.has('clientid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Client Id field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Client business account ID")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-sitemap'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 1? 'required' : ''))),
      expression: "`${userDetails.utype == 1? 'required' : ''}`"
    }],
    class: {
      'error': _vm.errors.has('ClientBusinessAccountId')
    },
    staticStyle: {
      "z-index": "999",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "options": _vm.clientBusinessAccountIds,
      "name": "ClientBusinessAccountId",
      "id": "ClientBusinessAccountId",
      "placeholder": "ClientBusinessAccount",
      "custom-label": _vm.clientBusinessAccountIdLabel,
      "track-by": "ClientBusinessAccountId",
      "multiple": true,
      "optionHeight": 100,
      "hide-selected": true
    },
    model: {
      value: (_vm.res_ClientBusinessAccountId),
      callback: function($$v) {
        _vm.res_ClientBusinessAccountId = $$v
      },
      expression: "res_ClientBusinessAccountId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ClientBusinessAccountId')),
      expression: "errors.has('ClientBusinessAccountId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The ClientBusinessAccountId  field is required.")])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3),
      expression: "userDetails.utype == 2 || userDetails.utype == 3"
    }],
    staticClass: "form-group row",
    attrs: {
      "id": "divAuDuReff"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Department Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-globe'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.DepartmentID),
      expression: "userDetails.DepartmentID"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "DepartmentID",
      "id": "DepartmentID"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.DepartmentID = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getSubdepartmentData(_vm.userDetails.DepartmentID)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a Department")]), _vm._v(" "), _vm._l((_vm.departmentList), function(department_obj) {
    return _c('option', {
      domProps: {
        "value": department_obj.DepartmentID
      }
    }, [_vm._v(_vm._s(department_obj.DepartmentName))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('DepartmentID')),
      expression: "errors.has('DepartmentID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Department Id field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Sub Department Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-sitemap'></i>"
    }
  }, [_c('Multiselect', {
    class: {
      'error': _vm.errors.has('SubdepartmentID')
    },
    staticStyle: {
      "z-index": "999",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "options": _vm.subdepartmentList,
      "name": "SubdepartmentID",
      "id": "SubdepartmentID",
      "placeholder": "Subdepartment",
      "label": "Subdepartment",
      "track-by": "SubdepartmentID",
      "multiple": true,
      "optionHeight": 100,
      "hide-selected": true
    },
    model: {
      value: (_vm.userDetails.SubdepartmentID),
      callback: function($$v) {
        _vm.userDetails.SubdepartmentID = $$v
      },
      expression: "userDetails.SubdepartmentID"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SubdepartmentID')),
      expression: "errors.has('SubdepartmentID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Subdepartment Id field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Designation Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-globe'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.DesignationID),
      expression: "userDetails.DesignationID"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "DesignationID",
      "id": "DesignationID"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.DesignationID = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getReportingUserData]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a Designation")]), _vm._v(" "), _vm._l((_vm.designationList), function(designation_obj) {
    return _c('option', {
      domProps: {
        "value": designation_obj.DesignationID
      }
    }, [_vm._v(_vm._s(designation_obj.Designation))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('DesignationID')),
      expression: "errors.has('DesignationID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Designation Id field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Reporting To")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.ReportingUserID),
      expression: "userDetails.ReportingUserID"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ReportingUserID",
      "id": "ReportingUserID"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.ReportingUserID = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a Reporting to User")]), _vm._v(" "), _vm._l((_vm.ReportingUserData), function(reporting_obj) {
    return _c('option', {
      domProps: {
        "value": reporting_obj.userid
      }
    }, [_vm._v(_vm._s(reporting_obj.FirstName) + " " + _vm._s(reporting_obj.LastName))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ReportingUserID')),
      expression: "errors.has('ReportingUserID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Reporting To field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Reffered By")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Reffered By",
      "name": "ReferredBy",
      "id": "ReferredBy"
    },
    model: {
      value: (_vm.userDetails.ReferredBy),
      callback: function($$v) {
        _vm.userDetails.ReferredBy = $$v
      },
      expression: "userDetails.ReferredBy"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('refferedby')),
      expression: "errors.has('refferedby')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The ReferredBy field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Extension No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true, 'error': _vm.errors.has('ExtensionNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Extension No",
      "name": "ExtensionNo",
      "id": "ExtensionNo"
    },
    model: {
      value: (_vm.userDetails.ExtensionNo),
      callback: function($$v) {
        _vm.userDetails.ExtensionNo = $$v
      },
      expression: "userDetails.ExtensionNo"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ExtensionNo')),
      expression: "errors.has('ExtensionNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Extension No field is required.")])], 1)], 1)])]), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3),
      expression: "userDetails.utype == 2 || userDetails.utype == 3"
    }],
    attrs: {
      "id": "AuDuOutHubId"
    }
  }, [_c('legend', [_vm._v("Third Party Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 3),
      expression: "userDetails.utype == 3"
    }],
    staticClass: "col-md-4",
    attrs: {
      "id": "outSourceId"
    }
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Outsourcing Id")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-globe'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.OutSourcingID),
      expression: "userDetails.OutSourcingID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 3 ? 'required' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('OutSourcingID')
    },
    attrs: {
      "name": "OutSourcingID",
      "id": "OutSourcingID"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.OutSourcingID = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a Outsourcing")]), _vm._v(" "), _vm._l((_vm.OutsourcingData), function(outsourcing_obj) {
    return _c('option', {
      domProps: {
        "value": outsourcing_obj.id
      }
    }, [_vm._v(_vm._s(outsourcing_obj.label))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('OutSourcingID')),
      expression: "errors.has('OutSourcingID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Outsourcing Id field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Id")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-sitemap'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 2 || _vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 2 || userDetails.utype == 3 ? 'required' : ''}`"
    }],
    class: {
      'error': _vm.errors.has('HubId')
    },
    staticStyle: {
      "z-index": "999",
      "border": "1px solid #c2cfd6"
    },
    attrs: {
      "options": _vm.hubServiceCenterList,
      "name": "HubId",
      "id": "HubId",
      "placeholder": "Select Hub",
      "label": "HubName",
      "track-by": "HubName",
      "multiple": _vm.multiple(),
      "optionHeight": 100,
      "hide-selected": true
    },
    model: {
      value: (_vm.userDetails.HubId),
      callback: function($$v) {
        _vm.userDetails.HubId = $$v
      },
      expression: "userDetails.HubId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('HubId')),
      expression: "errors.has('HubId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Hub Id field is required.")])], 1)], 1)])]), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 2),
      expression: "userDetails.utype == 2"
    }],
    attrs: {
      "id": "isActiveReportAdmin"
    }
  }, [_c('legend', [_vm._v("Active/Inactive Flags")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Is Active Report Admin")]), _vm._v(" "), _c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.string",
      value: (_vm.userDetails.IsActiveReportAdmin),
      expression: "userDetails.IsActiveReportAdmin",
      modifiers: {
        "string": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "IsActiveReportAdmin0",
      "name": "IsActiveReportAdmin",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsActiveReportAdmin, "true")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsActiveReportAdmin = "true"
      }
    }
  }), _vm._v("Yes\n                  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.string",
      value: (_vm.userDetails.IsActiveReportAdmin),
      expression: "userDetails.IsActiveReportAdmin",
      modifiers: {
        "string": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "IsActiveReportAdmin1",
      "name": "IsActiveReportAdmin",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsActiveReportAdmin, "false")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsActiveReportAdmin = "false"
      }
    }
  }), _vm._v("No\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('IsActiveReportAdmin')),
      expression: "errors.has('IsActiveReportAdmin')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Is Active Report Admin field is required.")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  })])]), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 3),
      expression: "userDetails.utype == 3"
    }],
    attrs: {
      "id": "fieldDeliveryuser"
    }
  }, [_c('legend', [_vm._v("Delivery User Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Employee Category")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 3 ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.EmployeeCategory),
      expression: "userDetails.EmployeeCategory"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('EmployeeCategory')
    },
    attrs: {
      "name": "EmployeeCategory",
      "id": "EmployeeCategory"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.EmployeeCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.getEmpTypeData()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a Employee Category")]), _vm._v(" "), _vm._l((_vm.empCategoryList), function(employeecategory_obj) {
    return _c('option', {
      domProps: {
        "value": employeecategory_obj.EmpCategoryId
      }
    }, [_vm._v(_vm._s(employeecategory_obj.EmpCategoryName))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('EmployeeCategory')),
      expression: "errors.has('EmployeeCategory')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Employee Category field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Employee Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 3 ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.EmpType),
      expression: "userDetails.EmpType"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('EmpType')
    },
    attrs: {
      "name": "EmpType",
      "id": "EmpType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.EmpType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a Employee Type")]), _vm._v(" "), _vm._l((_vm.empTypeList), function(employee_obj) {
    return _c('option', {
      domProps: {
        "value": employee_obj.EmpTypeId
      }
    }, [_vm._v(_vm._s(employee_obj.EmpTypeName))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('EmpType')),
      expression: "errors.has('EmpType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Employee Type field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Weekly Off")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.WeeklyOff),
      expression: "userDetails.WeeklyOff"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 3 ? 'required' : ''}`"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('WeeklyOff')
    },
    attrs: {
      "name": "WeeklyOff",
      "id": "WeeklyOff"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.WeeklyOff = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Weekly Off")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SUN"
    }
  }, [_vm._v("Sunday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MON"
    }
  }, [_vm._v("Monday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TUE"
    }
  }, [_vm._v("Tuesday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WED"
    }
  }, [_vm._v("Wednesday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "THU"
    }
  }, [_vm._v("Thursday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FRI"
    }
  }, [_vm._v("Friday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SAT"
    }
  }, [_vm._v("Saturday")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('WeeklyOff')),
      expression: "errors.has('WeeklyOff')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Weekly Off field is required.")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Is SR")]), _vm._v(" "), _c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.string",
      value: (_vm.userDetails.IsSR),
      expression: "userDetails.IsSR",
      modifiers: {
        "string": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "IsSR0",
      "name": "IsSR",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsSR, "true")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsSR = "true"
      }
    }
  }), _vm._v("Yes\n                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.string",
      value: (_vm.userDetails.IsSR),
      expression: "userDetails.IsSR",
      modifiers: {
        "string": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "IsSR1",
      "name": "IsSR",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsSR, "false")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsSR = "false"
      }
    }
  }), _vm._v("No\n                   "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('IsSR')),
      expression: "errors.has('IsSR')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Is SR field is required.")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Is Agent")]), _vm._v(" "), _c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsAgent),
      expression: "userDetails.IsAgent"
    }],
    attrs: {
      "type": "radio",
      "id": "IsAgent0",
      "name": "IsAgent",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsAgent, "true")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsAgent = "true"
      }
    }
  }), _vm._v("Yes\n                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsAgent),
      expression: "userDetails.IsAgent"
    }],
    attrs: {
      "type": "radio",
      "id": "IsAgent1",
      "name": "IsAgent",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsAgent, "false")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsAgent = "false"
      }
    }
  }), _vm._v("No\n                   "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('IsAgent')),
      expression: "errors.has('IsAgent')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Is Agent field is required.")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Is OnRoll")]), _vm._v(" "), _c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsOnRole),
      expression: "userDetails.IsOnRole"
    }],
    attrs: {
      "type": "radio",
      "id": "IsOnRole0",
      "name": "IsOnRole",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsOnRole, "true")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsOnRole = "true"
      }
    }
  }), _vm._v("Yes\n                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsOnRole),
      expression: "userDetails.IsOnRole"
    }],
    attrs: {
      "type": "radio",
      "id": "IsOnRole1",
      "name": "IsOnRole",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsOnRole, "false")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsOnRole = "false"
      }
    }
  }), _vm._v("No\n                   "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('IsOnRole')),
      expression: "errors.has('IsOnRole')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Is OnRoll field is required.")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Position Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.string",
      value: (_vm.userDetails.PositionType),
      expression: "userDetails.PositionType",
      modifiers: {
        "string": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 3 ? 'required' : ''}`"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('PositionType')
    },
    attrs: {
      "name": "PositionType",
      "id": "PositionType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.PositionType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Position Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "New"
    }
  }, [_vm._v("New Position")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Replacement"
    }
  }, [_vm._v("Replacement")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('PositionType')),
      expression: "errors.has('PositionType')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('PositionType')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.PositionType == 'Replacement'),
      expression: "userDetails.PositionType == 'Replacement'"
    }]
  }, [_c('label', [_vm._v("Replace SR Id")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.PositionType == 'Replacement'? 'required|numeric' : 'numeric'))),
      expression: "`${userDetails.PositionType == 'Replacement'? 'required|numeric' : 'numeric'}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('ReplaceSRId')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Replace SR Id",
      "name": "ReplaceSRId",
      "id": "ReplaceSRId"
    },
    model: {
      value: (_vm.userDetails.ReplaceSRId),
      callback: function($$v) {
        _vm.userDetails.ReplaceSRId = $$v
      },
      expression: "userDetails.ReplaceSRId"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ReplaceSRId')),
      expression: "errors.has('ReplaceSRId')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ReplaceSRId')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Comment")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-comments'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.Comment),
      expression: "userDetails.Comment"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Comment')
    },
    attrs: {
      "placeholder": "Enter Comment",
      "name": "Comment",
      "id": "Comment",
      "rows": 3
    },
    domProps: {
      "value": (_vm.userDetails.Comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userDetails.Comment = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Comment')),
      expression: "errors.has('Comment')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Comment field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-car'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 3 ? 'required' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('VehicleNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Vehicle No.",
      "name": "VehicleNo",
      "id": "VehicleNo"
    },
    model: {
      value: (_vm.userDetails.VehicleNo),
      callback: function($$v) {
        _vm.userDetails.VehicleNo = $$v
      },
      expression: "userDetails.VehicleNo"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('VehicleNo')),
      expression: "errors.has('VehicleNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Vehicle No. field is required.")])], 1)], 1)])]), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 3),
      expression: "userDetails.utype == 3"
    }],
    attrs: {
      "id": "fieldMobile"
    }
  }, [_c('legend', [_vm._v("Mobile Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Optional Mobile Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-mobile'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('digits:10'),
      expression: "'digits:10'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('OptionalMobileNumber')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Optional Mobile Number",
      "name": "OptionalMobileNumber",
      "maxlength": 10,
      "id": "OptionalMobileNumber"
    },
    model: {
      value: (_vm.userDetails.OptionalMobileNumber),
      callback: function($$v) {
        _vm.userDetails.OptionalMobileNumber = $$v
      },
      expression: "userDetails.OptionalMobileNumber"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('OptionalMobileNumber')),
      expression: "errors.has('OptionalMobileNumber')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('OptionalMobileNumber')) + "\n                   ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("IMEI Number")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-card'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter IMEI Number",
      "name": "IMEINumber",
      "id": "IMEINumber"
    },
    model: {
      value: (_vm.userDetails.IMEINumber),
      callback: function($$v) {
        _vm.userDetails.IMEINumber = $$v
      },
      expression: "userDetails.IMEINumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Is IMEI Changed")]), _vm._v(" "), _c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsIMEIChanged),
      expression: "userDetails.IsIMEIChanged"
    }],
    attrs: {
      "type": "radio",
      "id": "IsIMEIChanged0",
      "name": "IsIMEIChanged",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsIMEIChanged, "true")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsIMEIChanged = "true"
      }
    }
  }), _vm._v("Yes\n                     "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsIMEIChanged),
      expression: "userDetails.IsIMEIChanged"
    }],
    attrs: {
      "type": "radio",
      "id": "IsIMEIChanged1",
      "name": "IsIMEIChanged",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsIMEIChanged, "false")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsIMEIChanged = "false"
      }
    }
  }), _vm._v("No\n                     "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('IsIMEIChanged')),
      expression: "errors.has('IsIMEIChanged')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Is IMEI Changed field is required.")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("IMEI Change Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-times-o'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "placeholder": "Enter IMEI Change Date",
      "name": "IMEIChangeDate",
      "id": "IMEIChangeDate",
      "max": "9999-12-31"
    },
    model: {
      value: (_vm.userDetails.IMEIChangeDate),
      callback: function($$v) {
        _vm.userDetails.IMEIChangeDate = $$v
      },
      expression: "userDetails.IMEIChangeDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Is Mob Attend Login")]), _vm._v(" "), _c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsMobAttendLogin),
      expression: "userDetails.IsMobAttendLogin"
    }],
    attrs: {
      "type": "radio",
      "id": "IsMobAttendLogin0",
      "name": "IsMobAttendLogin",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsMobAttendLogin, "true")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsMobAttendLogin = "true"
      }
    }
  }), _vm._v("Yes\n                     "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsMobAttendLogin),
      expression: "userDetails.IsMobAttendLogin"
    }],
    attrs: {
      "type": "radio",
      "id": "IsMobAttendLogin1",
      "name": "IsMobAttendLogin",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsMobAttendLogin, "false")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsMobAttendLogin = "false"
      }
    }
  }), _vm._v("No\n                     "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('IsMobAttendLogin')),
      expression: "errors.has('IsMobAttendLogin')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Is SR field is required.")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Is Mob Number Verified By SR")]), _vm._v(" "), _c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsMobNumberVerifiedBySR),
      expression: "userDetails.IsMobNumberVerifiedBySR"
    }],
    attrs: {
      "type": "radio",
      "id": "IsMobNumberVerifiedBySR0",
      "name": "IsMobNumberVerifiedBySR",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsMobNumberVerifiedBySR, "true")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsMobNumberVerifiedBySR = "true"
      }
    }
  }), _vm._v("Yes\n                     "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsMobNumberVerifiedBySR),
      expression: "userDetails.IsMobNumberVerifiedBySR"
    }],
    attrs: {
      "type": "radio",
      "id": "IsMobNumberVerifiedBySR1",
      "name": "IsMobNumberVerifiedBySR",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsMobNumberVerifiedBySR, "false")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsMobNumberVerifiedBySR = "false"
      }
    }
  }), _vm._v("No\n                     "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('IsMobNumberVerifiedBySR')),
      expression: "errors.has('IsMobNumberVerifiedBySR')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Is SR field is required.")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Is Verified")]), _vm._v(" "), _c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsVerified),
      expression: "userDetails.IsVerified"
    }],
    attrs: {
      "type": "radio",
      "id": "IsVerified0",
      "name": "IsVerified",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsVerified, "true")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsVerified = "true"
      }
    }
  }), _vm._v("Yes\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsVerified),
      expression: "userDetails.IsVerified"
    }],
    attrs: {
      "type": "radio",
      "id": "IsVerified1",
      "name": "IsVerified",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsVerified, "false")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsVerified = "false"
      }
    }
  }), _vm._v("No\n                    "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('IsVerified')),
      expression: "errors.has('IsVerified')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Is SR field is required.")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Verification Code")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-card'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Verification Code",
      "name": "VerificationCode",
      "id": "VerificationCode",
      "readonly": true,
      "disabled": true
    },
    model: {
      value: (_vm.userDetails.VerificationCode),
      callback: function($$v) {
        _vm.userDetails.VerificationCode = $$v
      },
      expression: "userDetails.VerificationCode"
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 3),
      expression: "userDetails.utype == 3"
    }],
    attrs: {
      "id": "fieldOther"
    }
  }, [_c('legend', [_vm._v("Other Details")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Aadhaar Card No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Aadhaar Card No",
      "name": "AadhaarCardNo",
      "id": "AadhaarCardNo"
    },
    model: {
      value: (_vm.userDetails.AadhaarCardNo),
      callback: function($$v) {
        _vm.userDetails.AadhaarCardNo = $$v
      },
      expression: "userDetails.AadhaarCardNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("PAN No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter PAN No",
      "name": "PANNo",
      "id": "PANNo"
    },
    model: {
      value: (_vm.userDetails.PANNo),
      callback: function($$v) {
        _vm.userDetails.PANNo = $$v
      },
      expression: "userDetails.PANNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Licence No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-id-card'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 3 ? 'required' : ''}`"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('LicenceNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Licence No",
      "name": "LicenceNo",
      "id": "LicenceNo"
    },
    model: {
      value: (_vm.userDetails.LicenceNo),
      callback: function($$v) {
        _vm.userDetails.LicenceNo = $$v
      },
      expression: "userDetails.LicenceNo"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('LicenceNo')),
      expression: "errors.has('LicenceNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Licence No field is required.")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Is Admin To Save Location")]), _vm._v(" "), _c('b-form-fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsAdminToSaveLocation),
      expression: "userDetails.IsAdminToSaveLocation"
    }],
    attrs: {
      "type": "radio",
      "id": "IsAdminToSaveLocation0",
      "name": "IsAdminToSaveLocation",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsAdminToSaveLocation, "true")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsAdminToSaveLocation = "true"
      }
    }
  }), _vm._v("Yes\n                   "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.IsAdminToSaveLocation),
      expression: "userDetails.IsAdminToSaveLocation"
    }],
    attrs: {
      "type": "radio",
      "id": "IsAdminToSaveLocation1",
      "name": "IsAdminToSaveLocation",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.userDetails.IsAdminToSaveLocation, "false")
    },
    on: {
      "__c": function($event) {
        _vm.userDetails.IsAdminToSaveLocation = "false"
      }
    }
  }), _vm._v("No\n                 ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Payment Mode Updated By")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-card'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Payment Mode Updated By",
      "name": "paymentModeUpdatedBy",
      "id": "paymentModeUpdatedBy"
    },
    model: {
      value: (_vm.userDetails.paymentModeUpdatedBy),
      callback: function($$v) {
        _vm.userDetails.paymentModeUpdatedBy = $$v
      },
      expression: "userDetails.paymentModeUpdatedBy"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("T-Shirt Size")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-globe'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.TShirtSize),
      expression: "userDetails.TShirtSize"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.EmpType == 1 ? 'required' : ''))),
      expression: "`${userDetails.EmpType == 1 ? 'required' : ''}`"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('TShirtSize')
    },
    attrs: {
      "name": "TShirtSize",
      "id": "TShirtSize"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.TShirtSize = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select T-Shirt Size")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "S"
    }
  }, [_vm._v("S")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("M")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "L"
    }
  }, [_vm._v("L")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XL"
    }
  }, [_vm._v("XL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XXL"
    }
  }, [_vm._v("XXL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XXXL"
    }
  }, [_vm._v("XXXL")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('LicenceNo')),
      expression: "errors.has('LicenceNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('TShirtSize')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shift Timings")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-clock-o'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.userDetails.utype == 3 ? 'required' : ''))),
      expression: "`${userDetails.utype == 3 ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.userDetails.ShiftTimings),
      expression: "userDetails.ShiftTimings"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('ShiftTimings')
    },
    attrs: {
      "name": "ShiftTimings",
      "id": "ShiftTimings"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userDetails.ShiftTimings = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Shift Timings")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7AM To 3PM"
    }
  }, [_vm._v("7AM To 3PM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9AM To 5PM"
    }
  }, [_vm._v("9AM To 5PM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12AM To 8PM"
    }
  }, [_vm._v("12AM To 8PM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3PM To 11PM"
    }
  }, [_vm._v("3PM To 11PM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11PM To 7AM"
    }
  }, [_vm._v("11PM To 7AM")])])])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ShiftTimings')),
      expression: "errors.has('ShiftTimings')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Shift Timings field is required.")])], 1)])]), _vm._v(" "), _c('fieldset', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userDetails.utype == 3),
      expression: "userDetails.utype == 3"
    }],
    attrs: {
      "id": "fieldUpload"
    }
  }, [_c('legend', [_vm._v("Upload Documents / Images")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Upload/Capture Photo")]), _vm._v(" "), _vm._l((_vm.DelUserPhotoScanFiles), function(data, index) {
    return _c('a', {
      attrs: {
        "title": "Download",
        "href": ("" + (data.url))
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "font-size": "20px",
        "color": "#4b8cbb",
        "margin-left": "10px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-card'></i>"
    }
  }, [_c('input', {
    class: {
      'form-control': true
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload/Capture Photo",
      "name": "Xb_DeliveryUser_PhotoFileUpload",
      "id": "Xb_DeliveryUser_PhotoFileUpload"
    },
    on: {
      "change": _vm.onUpload
    }
  })])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Upload/Capture Licence")]), _vm._v(" "), _vm._l((_vm.DelUserLicenceScanFiles), function(data, index) {
    return _c('a', {
      attrs: {
        "title": "Download",
        "href": ("" + (data.url))
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "font-size": "20px",
        "color": "#4b8cbb",
        "margin-left": "10px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-card'></i>"
    }
  }, [_c('input', {
    class: {
      'form-control': true
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload/Capture Licence",
      "name": "Xb_DeliveryUser_LicenceFileUpload",
      "id": "Xb_DeliveryUser_LicenceFileUpload"
    },
    on: {
      "change": _vm.onUpload
    }
  })])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Upload Police Verification")]), _vm._v(" "), _vm._l((_vm.DlvUserPoliceVerificationScanFiles), function(data, index) {
    return _c('a', {
      attrs: {
        "title": "Download",
        "href": ("" + (data.url))
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "font-size": "20px",
        "color": "#4b8cbb",
        "margin-left": "10px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-card'></i>"
    }
  }, [_c('input', {
    class: {
      'form-control': true
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload Police Verification",
      "name": "Xb_DeliveryUser_PoliceVerificationFileUpload",
      "id": "Xb_DeliveryUser_PoliceVerificationFileUpload"
    },
    on: {
      "change": _vm.onUpload
    }
  })])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Upload Aadhaar Card")]), _vm._v(" "), _vm._l((_vm.DlvUserAadhaarCardVerificationScanFiles), function(data, index) {
    return _c('a', {
      attrs: {
        "title": "Download",
        "href": ("" + (data.url))
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "font-size": "20px",
        "color": "#4b8cbb",
        "margin-left": "10px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-card'></i>"
    }
  }, [_c('input', {
    class: {
      'form-control': true
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload Aadhaar Card",
      "name": "Xb_DeliveryUser_AadhaarCardVerificationFileUpload",
      "id": "Xb_DeliveryUser_AadhaarCardVerificationFileUpload"
    },
    on: {
      "change": _vm.onUpload
    }
  })])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Upload PAN Card")]), _vm._v(" "), _vm._l((_vm.DlvUserPANCardVerificationScanFiles), function(data, index) {
    return _c('a', {
      attrs: {
        "title": "Download",
        "href": ("" + (data.url))
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "font-size": "20px",
        "color": "#4b8cbb",
        "margin-left": "10px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-address-card'></i>"
    }
  }, [_c('input', {
    class: {
      'form-control': true
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload PAN Card",
      "name": "Xb_DeliveryUser_PANCardVerificationFileUpload",
      "id": "Xb_DeliveryUser_PANCardVerificationFileUpload"
    },
    on: {
      "change": _vm.onUpload
    }
  })])], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "userfooter form-actions"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "size": "vlg"
    }
  }, [_vm._v("Save")]), _vm._v(" \n          "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "size": "vlg"
    },
    on: {
      "click": _vm.closeRegistration
    }
  }, [_vm._v("Cancel")])])])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-046c9c15","hasScoped":true}!./src/views/components/register/register.component.html
// module id = 807
// module chunks = 1